export const BUILT_IN_VIEW_SCALE_1_PER_2_INCH = 1 / 2 / 12;
export const BUILT_IN_VIEW_SCALE_1_PER_4_INCH = 1 / 4 / 12;
export const BUILT_IN_VIEW_SCALE_1_PER_8_INCH = 1 / 8 / 12;

export const DEFAULT_MODEL_VIEW_SCALE = BUILT_IN_VIEW_SCALE_1_PER_4_INCH;

/** List of built-in view scale factors. */
export const BuiltinViewScaleFactors = [
  1 / 16 / 12,
  3 / 32 / 12,
  BUILT_IN_VIEW_SCALE_1_PER_8_INCH,
  3 / 16 / 12,
  BUILT_IN_VIEW_SCALE_1_PER_4_INCH,
  3 / 8 / 12,
  BUILT_IN_VIEW_SCALE_1_PER_2_INCH,
  3 / 4 / 12,
  1 / 12,
  3 / 24,
  3 / 12,
  1,
];
